import React, { PureComponent } from 'react';
import { LEGAL_HIPAA_URL } from '../../constants/index';
import Link from '../Link';

type Props = {
  className?: string;
};

export default class HipaaConsent extends PureComponent<Props> {
  render = () => (
    <Link className={this.props.className} to={LEGAL_HIPAA_URL}>
      HIPAA Authorization
    </Link>
  );
}
